import * as Yup from 'yup';
import {IModel} from '~/lib/model';
import {ISourceDomains, SourceDomainsSchema} from '~/modules/Sources/models/IDomains';

export interface ILimitedSelfServeSource extends IModel {
    name: string;
    domains: ISourceDomains[];
}

export const LimitedSelfServeSource = Yup.object().shape<ILimitedSelfServeSource>({
  id: Yup.number().nullable(),
  name: Yup.string().required('Name is required'),
  domains: Yup.array().of(SourceDomainsSchema),
});

export const defaultLimitedSelfServeSource: ILimitedSelfServeSource = {
    id: null,
    name: '',
    domains: [],
};
